export const instance = 'https://devsodo.b2clogin.com';
export const baseURL= 'https://k365appapi.azurewebsites.net';
//export const baseURL = 'https://localhost:44331';